const es = {
  GO_TO_COURSE_DETAIL: 'Ver detalhes do curso',
  GO_TO_COURSE_DETAIL_SHORT: 'Ver detalhes',
  SEARCH_COURSE_BY: 'Por',
};

export default es;
